import React from 'react';
import styled from 'styled-components';

import { HeaderContainer, HeaderMixin } from '../../shared/styles';
import { DescriptionColumn, NameColumn, SlugColumn } from './styles';

const NameColumnHeader = styled(NameColumn)`
  ${HeaderMixin}
`;

const SlugColumnHeader = styled(SlugColumn)`
  ${HeaderMixin}
`;

const DescriptionColumnHeader = styled(DescriptionColumn)`
  ${HeaderMixin}
`;

export default function Header() {
  return (
    <HeaderContainer>
      <NameColumnHeader>Name</NameColumnHeader>
      <SlugColumnHeader>Slug</SlugColumnHeader>
      <DescriptionColumnHeader>Description</DescriptionColumnHeader>
    </HeaderContainer>
  );
}
